// Locale cookie utilities. Cookie name kept as `NEXT_LOCALE` for parity with
// admin-nextjs (any user with the legacy cookie keeps their pref on first
// load). One-year max-age, SameSite=Lax, non-HttpOnly (UI preference only).

export const LOCALES = ["en", "vi"] as const;
export type Locale = (typeof LOCALES)[number];
export const DEFAULT_LOCALE: Locale = "en";

const COOKIE_NAME = "NEXT_LOCALE";
const MAX_AGE_SECONDS = 365 * 24 * 60 * 60;

export function isLocale(value: string | undefined | null): value is Locale {
  return value !== null && value !== undefined && (LOCALES as readonly string[]).includes(value);
}

export function getLocaleFromCookie(): Locale {
  if (typeof document === "undefined") return DEFAULT_LOCALE;
  const match = document.cookie.match(new RegExp(`(?:^|; )${COOKIE_NAME}=([^;]+)`));
  const raw = match?.[1];
  return isLocale(raw) ? raw : DEFAULT_LOCALE;
}

export function writeLocaleCookie(locale: Locale): void {
  if (typeof document === "undefined") return;
  document.cookie = `${COOKIE_NAME}=${locale}; path=/; max-age=${MAX_AGE_SECONDS}; SameSite=Lax`;
}
